import React from 'react'
import SampleValuesSetManagement from '../../components/SampleValuesSetManagement'

const SampleValuesSetPage = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <SampleValuesSetManagement />
    </div>
  )
}

export default SampleValuesSetPage
